import React from "react";
import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import Application from "application/components/Application";
import { theme } from "theme.js";
import { creatorQueryClient } from "../application/queryClients";
import { AppQueryClientProvider } from "../application/AppQueryClientProvider";

const Root = ({ store, history }) => (
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <CssBaseline />
          <AppQueryClientProvider client={creatorQueryClient}>
            <Application history={history} />
          </AppQueryClientProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
);

export default Root;
